import {
  SourceEntityMigrationType,
  type ISourceEntity,
  ISourceEntityTypes,
} from '@principle-theorem/practice-migrations/interfaces';
import { TypeGuard, type Timezone } from '@principle-theorem/shared';
import { isNumber, isString } from 'lodash';
import { BaseSourceEntity } from '../../../source/base-source-entity';
import { SourceEntity } from '../../../source/source-entity';

export const PATIENT_NOTE_TYPE_RESOURCE_TYPE = 'patientNoteTypes';

export const PATIENT_NOTE_TYPE_SOURCE_ENTITY: ISourceEntity = SourceEntity.init(
  {
    metadata: {
      label: 'Patient Note Types',
      description: '',
      idPrefix: PATIENT_NOTE_TYPE_RESOURCE_TYPE,
      migrationType: SourceEntityMigrationType.Automatic,
    },
  }
);

export interface IOasisPatientNoteType {
  id: number;
  name: string;
}

export function isOasisPatientNoteType(
  item: unknown,
  logError: boolean
): item is IOasisPatientNoteType {
  return TypeGuard.interface<IOasisPatientNoteType>(
    {
      id: isNumber,
      name: isString,
    },
    logError
  )(item);
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IOasisPatientNoteTypeTranslations {}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IOasisPatientNoteTypeFilters {}

const PATIENT_NOTE_TYPE_SOURCE_QUERY = `
SELECT
	convert_to_integer(REGEXP_REPLACE(SKEY, 'PTNOTESNE', '')) AS id,
	F1 AS name
FROM SYTBLENT
WHERE SKEY LIKE 'PTNOTESNE%'
`;

export type OasisPatientNoteType = ISourceEntityTypes<
  IOasisPatientNoteType,
  IOasisPatientNoteTypeTranslations,
  IOasisPatientNoteTypeFilters
>;

export class PatientNoteTypeSourceEntity extends BaseSourceEntity<OasisPatientNoteType> {
  sourceEntity = PATIENT_NOTE_TYPE_SOURCE_ENTITY;
  entityResourceType = PATIENT_NOTE_TYPE_RESOURCE_TYPE;
  sourceQuery = PATIENT_NOTE_TYPE_SOURCE_QUERY;
  verifySourceFn = isOasisPatientNoteType;

  translate(
    _data: IOasisPatientNoteType,
    _timezone: Timezone
  ): IOasisPatientNoteTypeTranslations {
    return {};
  }

  getSourceRecordId(data: IOasisPatientNoteType): number {
    return data.id;
  }

  getSourceLabel(data: IOasisPatientNoteType): string {
    return `${data.id} - ${data.name}`;
  }

  getFilterData(
    _data: IOasisPatientNoteType,
    _timezone: Timezone
  ): IOasisPatientNoteTypeFilters {
    return {};
  }
}
